import angular from 'angular';
import 'angular-filter';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './header-game-developers.jade';

export class HeaderGameDevelopersController {
  /* @ngInject */
  constructor(GameDevelopersResource, currentUser, currentGameDeveloper, header) {
    this.currentGameDeveloper = currentGameDeveloper;
    this.currentUser = currentUser;
    this.header = header;
    this.disposables = [];

    this.disposables.push(this.currentGameDeveloper.subscribe(gameDeveloper => {
      this.gameDeveloper = gameDeveloper;
    }));

    this.disposables.push(this.currentUser.subscribe(user => {
      if(user) {
        if(user.hasRole(['ADMIN', 'GG_ACCOUNT_MANAGER','AGENCY', 'ADMIN_AGENCY', 'OPERATION_MANAGER'])) {
          this.showGameDevelopersDropdown = true;
          GameDevelopersResource.getList().then(gameDevelopers => {
            this.gameDevelopers = gameDevelopers;
            if(this.gameDevelopers.length > 0) {
              this.gameDeveloperName = gameDevelopers[0].company_name;
            }
          });
        } else {
          this.showGameDevelopersDropdown = false;
        }
      }
      return this.user = user;
    }));

    this.disposeObservable = (d) => { d.dispose() };
    this.$onDestroy = () => { _.forEach(this.disposables, (d) => this.disposeObservable(d)) };
  }

  updateCurrentGameDeveloper(gameDeveloper) {
    this.currentGameDeveloper.onNext(gameDeveloper);
  }
}

export let HeaderGameDevelopersComponent = {
  template: () => { return template },
  controller: HeaderGameDevelopersController,
  controllerAs: 'vm',
  bindings: {}
};


export default angular.module('header.gameDevelopers', [
  'ui.router',
  'ui.select',
  'angular.filter',
  ServicesModule.name,
  ResourcesModule.name
])
.component('headerGameDevelopers', HeaderGameDevelopersComponent);


/** WEBPACK FOOTER **
 ** ./src/common/header/header-game-developers.js
 **/